var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResApplicationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 2H5.375C4.47989 2 3.62145 2.35558 2.98851 2.98851C2.35558 3.62145 2 4.47989 2 5.375V32.375C2 33.2701 2.35558 34.1285 2.98851 34.7615C3.62145 35.3944 4.47989 35.75 5.375 35.75H25.625C26.5201 35.75 27.3785 35.3944 28.0115 34.7615C28.6444 34.1285 29 33.2701 29 32.375V13.8125L17.1875 2Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 2V13.8125H29",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResApplicationsIcon);
export default __webpack_public_path__ + "static/media/ResApplicationsIcon.f04f9a2e9f07a156370b44015dd4dde3.svg";
export { ForwardRef as ReactComponent };